import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import useTranslate from '../../Hooks/useTranslate';
import Switch from '../Inputs/FormSwitch';

/** What the value below it is. */
const Caption = ({ children }) => (
  <Typography
    variant="caption"
    color="textSecondary"
    sx={{ mb: 0.5, display: 'block', fontWeight: 600 }}
  >
    {children}
  </Typography>
);

/**
 * Displays a field's value instead of an input. Any field type renders through this when its
 * descriptor sets `readOnly`, which is what a detail surface uses; the descriptor is otherwise
 * identical to the one a form or a filter panel would use.
 */
export const ReadOnlyValue = ({ label, value, id }) => {
  const translate = useTranslate();

  if (typeof value === 'boolean') {
    return (
      <Box sx={{ mt: 2, mb: 1 }}>
        <Switch id={id} checked={value} disabled label={translate(label)} />
      </Box>
    );
  }

  if (Array.isArray(value)) {
    return (
      <Box sx={{ mt: 2, mb: 1 }}>
        <Caption>{translate(label)}</Caption>
        <Grid container spacing={1}>
          {value.map((entry, index) => (
            <Grid size={{ xs: 12, sm: 6 }} key={index}>
              <Paper
                sx={{
                  p: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '6px',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, wordBreak: 'break-word' }}
                >
                  {entry}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Caption>{translate(label)}</Caption>
      <Box
        sx={{
          p: '12px',
          borderRadius: '8px',
          minHeight: '40px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {value ?? ''}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReadOnlyValue;
